import AccountInfoError from '../../../mocks/api/account-info-error.json';

export const mockErrorApi = {
  //'POST:/\\S*tags-mock' : AccountInfoError
  // 'GET:/\\S*/v2/profile/v1/account/info/\\w+': AccountInfoError
};
